import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Fade from 'react-reveal/Fade'

const Timeline = ({ title = 'Headland Timeline', events = null, backgroundImage = null }) => {

  return (
    <section className='timeline'>
      {backgroundImage?.localFile && <GatsbyImage className='timeline__bg' image={getImage(backgroundImage.localFile)} alt={title} />}
      <div className='timeline__inner'>
        {events?.length > 0 &&
          <div className='timeline__events'>
            <div className='timeline__event'>
              <div className='timeline__year'>{title}</div>
              <div className='timeline__content'>&nbsp;</div>
            </div>
            {events?.map((el, i) => (
              <Fade key={i}>
                <div className='timeline__event' key={i}>
                  <div className='timeline__year'>{el.year}</div>
                  <div className='timeline__content'>
                    <div className='timeline__text' dangerouslySetInnerHTML={{ __html: el.content }} />
                    <div className='timeline__image'>
                      {el.image?.localFile && <GatsbyImage image={getImage(el.image.localFile)} alt={`Headland Timeline - ${el.year}`} />}
                    </div>
                  </div>
                </div>
              </Fade>
            ))}
          </div>
        }
      </div>
    </section>
  )
}

export default Timeline